import { UseQueryOptions, useQuery } from 'react-query';
import { BNPLApi, MerchantStatusResponse } from '@frontend/api-buy-now-pay-later';

export type UseSunbitStatusQueryProps = {
  locationId: string | undefined;
};

export const sunbitStatusQueryKey = (locationId: string | undefined) => ['sunbitStatus', locationId];

export const useSunbitStatusQuery = (
  { locationId }: UseSunbitStatusQueryProps,
  options: UseQueryOptions<MerchantStatusResponse, unknown> = {}
) => {
  return useQuery({
    queryKey: sunbitStatusQueryKey(locationId),
    queryFn: async () => BNPLApi.buyNowPayLater.status(locationId ?? ''),
    ...options,
    enabled: !!locationId && options.enabled,
  });
};
